import EsaglikAdresDTO from "src/models/Genel/EsaglikAdresDTO";
import VwKimlikDTO from "src/models/Genel/VwKimlikDTO";
import api from "src/services/core/api";

const controllerName = "VwKimlikDTO";
export const kimlikApi = api.injectEndpoints({
    endpoints: builder => ({
        getByLoginKimlikId: builder.query<VwKimlikDTO, number>({
            query: (kimlikId) => {
                return {
                    url: controllerName + "/" + kimlikId,
                    method: "GET"
                }
            },
        }),
        getByKimlikId: builder.query<VwKimlikDTO, number>({
            query: (kimlikId) => {
                return {
                    url: controllerName + "/" + kimlikId,
                    method: "GET"
                }
            },
            providesTags: ["KimlikGuncelle"]
        }),
        IlilceGetir: builder.query<Array<EsaglikAdresDTO>, { seviye: number, ilKodu: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/ililcegetir",
                    method: "GET",
                    params: request
                }
            },
        }),
    }),
})

export const { useGetByLoginKimlikIdQuery, useGetByKimlikIdQuery, useIlilceGetirQuery } = kimlikApi;